import { PAGE_LINKS } from '@/router/pageConst'
import { corpService } from '@/services/corpService'
import { userService } from '@/services/userService'
import { observer } from 'mobx-react'
import React, { useEffect, useState } from 'react'
import { Navigate } from 'react-router'

interface Props {
  children: React.ReactNode
  mode?: 'professor' | 'default'
}

function AuthRenderer({ children, mode = 'default' }: Props) {
  const [loading, setLoading] = useState(true)
  const [hasUserInfo, setHasUserInfo] = useState<boolean>(false)
  const redirectLink = mode === 'default' ? PAGE_LINKS.index : PAGE_LINKS.professorLogin

  useEffect(() => {
    const one: boolean = Boolean(userService.userInfo)
    const two: boolean =
      mode === 'default' ? !userService.userInfo?.isExpert : Boolean(userService.userInfo?.isExpert)
    const hasUserInfo = one && two
    setHasUserInfo(hasUserInfo)
    if (hasUserInfo && !corpService.corpInfo) {
      corpService.getCorpInfo()
    }
  }, [userService.userInfo])

  useEffect(() => {
    userService
      .getUserInfo(true)
      .then(() => {
        setLoading(false)
      })
      .catch(() => {
        setLoading(false)
      })
  }, [])

  return loading ? null : hasUserInfo ? children : <Navigate to={redirectLink} />
}

export default observer(AuthRenderer)
